import { invoices } from "../stores.js";
import { API_URL, BTCPAY_URL, API_WS_URL } from "../config.js";
import axios from "axios";

export const formatInvoice = (address, amount) => {
    return "bitcoin:" + address + "?amount=" + amount
}

export const postInvoice = (id, invoiceData) => {
    const axiosClient = axios.create({
        baseURL: BTCPAY_URL,
        timeout: 5000,
        responseType: 'json',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "Basic T1E3MFdPaUNNa1kwTVBIN01vRWtSRW9MZEIxR0xSbFlQbzBrcmRDb0hWNw=="
        }
    });

    let ivs
    invoices.subscribe(i => ivs = i)
    let invoice = ivs.filter(iv => iv.id == id)
    if (invoice.length > 0) {
        if (Date.now() - invoice[0].expirationTime <= 0) {
            console.log("deleting old invoice")
            invoices.deleteInvoice(id)
            axiosClient.post("/invoices", invoiceData).then(response => {
                invoices.pushInvoice(response.data.data, id)
            });
        }
        else if (invoice[0].invoice.price != invoiceData.price){
            console.log("deleting old invoice man")
            invoices.deleteInvoice(id)
            axiosClient.post("/invoices", invoiceData).then(response => {
                invoices.pushInvoice(response.data.data, id)
            });
        }
        else{
            console.log("keeping old invoice but exitingjk")
        }
    }
    else {
        console.log("adding new invoice")
        axiosClient.post("/invoices", invoiceData).then(response => {
            invoices.pushInvoice(response.data.data, id)
        });
    }
}

export const watchInvoice = async (
    invoiceId,
    onPayment,
    onSettle,
    onExpire
) => {
    let ws = new WebSocket(`${API_WS_URL}/ws?invoice_id=${invoiceId}`);
    ws.onmessage = event => {
        let data = event.data;
        if (data != "") {
            let json = JSON.parse(data);
            switch (json.type) {
                case "NewPayment":
                    onPayment({
                        due: json.btc_due,
                        payments: json.payments
                    });
                    break;
                case "InvoiceSettled":
                    onSettle();
                    ws.close(200);
                    break;
                case "InvoiceExpired":
                    onExpire();
                    ws.close(200);
                    break;
            }
        }
    }
}
